import { render } from "./SubstitutesBadRequestsPage.vue?vue&type=template&id=3fc741f8&scoped=true"
import script from "./SubstitutesBadRequestsPage.vue?vue&type=script&lang=js"
export * from "./SubstitutesBadRequestsPage.vue?vue&type=script&lang=js"

import "./SubstitutesBadRequestsPage.vue?vue&type=style&index=0&id=3fc741f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc741f8"]])

export default __exports__